/**
 * Public SSM API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0-private
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
 /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';


import { BusinessImageListItemDto } from '../model/businessImageListItemDto';
import { VPError } from '../model/vPError';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class BusinessImagesViewService {

    protected basePath = '/';
    protected defaultHeaders = new HttpHeaders();
    protected configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Lazy check AmsAction:GET/api/BusinessImagesView/{businessId}/Images/Promotional AmsResource:{country}/{business}/_* 
     * @param businessId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPromotionalBusinessImageKeys(businessId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<BusinessImageListItemDto>>;
    public getPromotionalBusinessImageKeys(businessId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<BusinessImageListItemDto>>>;
    public getPromotionalBusinessImageKeys(businessId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<BusinessImageListItemDto>>>;
    public getPromotionalBusinessImageKeys(businessId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (businessId === null || businessId === undefined) {
            throw new Error('Required parameter businessId was null or undefined when calling getPromotionalBusinessImageKeys.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<BusinessImageListItemDto>>(`${this.basePath}/api/BusinessImagesView/${encodeURIComponent(String(businessId))}/Images/Promotional`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Lazy check AmsAction:GET/api/BusinessImagesView/{businessId}/Images/Promotional/{fileKey} AmsResource:{country}/{business}/_* 
     * @param businessId 
     * @param fileKey 
     * @param size 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPromotionalBusinessImageKeys_1(businessId: string, fileKey: string, size?: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public getPromotionalBusinessImageKeys_1(businessId: string, fileKey: string, size?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public getPromotionalBusinessImageKeys_1(businessId: string, fileKey: string, size?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public getPromotionalBusinessImageKeys_1(businessId: string, fileKey: string, size?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (businessId === null || businessId === undefined) {
            throw new Error('Required parameter businessId was null or undefined when calling getPromotionalBusinessImageKeys_1.');
        }

        if (fileKey === null || fileKey === undefined) {
            throw new Error('Required parameter fileKey was null or undefined when calling getPromotionalBusinessImageKeys_1.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (size !== undefined && size !== null) {
          queryParameters = queryParameters.set('size', <any>size);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Blob>(`${this.basePath}/api/BusinessImagesView/${encodeURIComponent(String(businessId))}/Images/Promotional/${encodeURIComponent(String(fileKey))}`,
            {
                // @ts-ignore
                responseType:'blob',
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Lazy check AmsAction:GET/api/BusinessImagesView/{businessId}/Images/Standard AmsResource:{country}/{business}/_* 
     * @param businessId 
     * @param size 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getStandardBusinessImage(businessId: string, size?: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public getStandardBusinessImage(businessId: string, size?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public getStandardBusinessImage(businessId: string, size?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public getStandardBusinessImage(businessId: string, size?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (businessId === null || businessId === undefined) {
            throw new Error('Required parameter businessId was null or undefined when calling getStandardBusinessImage.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (size !== undefined && size !== null) {
          queryParameters = queryParameters.set('size', <any>size);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Blob>(`${this.basePath}/api/BusinessImagesView/${encodeURIComponent(String(businessId))}/Images/Standard`,
            {
                // @ts-ignore
                responseType:'blob',
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
